/**
 * Created by whq on 20/11/18.
 */
// 字符串转日期  eg:1547136000000 => 2019-01-11
export function parseDataConcise(x) {
  const now = new Date(x)
  const dataObj = {
    y: now.getFullYear(),
    m: now.getMonth() + 1,
    d: now.getDate()
  }
  return dataObj.y + '-' + (dataObj.m < 10 ? '0' + dataObj.m : dataObj.m) + '-' + (dataObj.d < 10 ? '0' + dataObj.d : dataObj.d)
}
/*
字符串转日期    
第一步：获取到的时间是  eg:2020-11-20T01:41:51.000+0000(东八区与北京时间相差8小时+8) 
第二步：转换为时间格式的  => new Date(2020-11-20T01:41:51.000+0000).getTime() 即"1605836511000"  
第三步： 再通过自定义规则格式化成需要的日期时间   => 2010-11-20 09:41:51
*/ 
export function parseTime(time, cFormat) {
  if (time === undefined || time === null || time === '') {
    return '——'
  }
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    
    if (!!window.ActiveXObject || "ActiveXObject" in window){ 
      date = new Date(time.replace(/T/," ").replace(/-/g,"/").replace(/\.\d+(\+?.*$)/g,"$1"))
    }
    else {
      date = new Date(time)
    }
  
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay() //星期几  具体的数字
    /*
      var d=new Date()  //document.write(d.getDay()) =>  1
      var weekday=new Array(7)
      weekday[0]="Sunday"
      weekday[1]="Monday"
      weekday[2]="Tuesday"
      weekday[3]="Wednesday"
      weekday[4]="Thursday"
      weekday[5]="Friday"
      weekday[6]="Saturday"   //document.write("Today it is " + weekday[d.getDay()]) =>Monday
    */ 
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {    
    /*
    1.str.replace(oldvalue,newvalue)  一般是查找以第一次出现的
    2.正则表达式   
    y|m => 任意以y或m出现的  
    + 至少一个或多个   ? 0次或一次                   
    {n}出现n次  {n,m}重复n到m次，包括n和m
    
    */ 
    let value = formatObj[key]   //这是自定义星期几的格式
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] } //['键'][值]   
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
/*
获取的时间与当前时间做比较，来确定是多久时间之前
*/
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
        d.getMonth() +
        1 +
        '月' +
        d.getDate() +
        '日' +
        d.getHours() +
        '时' +
        d.getMinutes() +
        '分'
    )
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1) //返回字符在字符串当中最后出现的索引，如果没有，返回-1
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
// export function getByteLen(val) {
//   let len = 0
//   for (let i = 0; i < val.length; i++) {
//     if (val[i].match(/[^\x00-\xff]/gi) != null) {
//       len += 1
//     } else {
//       len += 0.5
//     }
//   }
//   return Math.floor(len)
// }

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if (!json) return ''
  return cleanArray(
      Object.keys(json).map(key => {
        if (json[key] === undefined) return ''
        return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
      })
  ).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
      '{"' +
      decodeURIComponent(search)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"') +
      '"}'
  )
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

export function scrollTo(element, to, duration) {
  if (duration <= 0) return
  const difference = to - element.scrollTop
  const perTick = (difference / duration) * 10
  setTimeout(() => {
    element.scrollTop = element.scrollTop + perTick
    if (element.scrollTop === to) return
    scrollTo(element, to, duration - 10)
  }, 10)
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
        classString.substr(0, nameIndex) +
        classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export const pickerOptions = [
  {
    text: '今天',
    onClick(picker) {
      const end = new Date()
      const start = new Date(new Date().toDateString())
      end.setTime(start.getTime())
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近一周',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      picker.$emit('pick', [start, end])
    }
  }
]

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}
/**
 * This is just a simple version of Array to heavy
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * 兼容ie的多行省略号截取
 * */ 
export function wordLimit(val){
  if(val !==undefined && val !== null && val.length>100){
    return val = val.substr(0,100)+'…'
  }else{
    return val
  }
  
}
// export function wordLimit1( c_name, word_length){
//   let cname=document.getElementsByClassName( c_name);
//   for(let i=0;i<cname.length;i++){
//     let nowHtml=cname[i].innerHTML;
//     let nowLength=cname[i].innerHTML.length;
//     if(nowLength > word_length){
//       return  cname[i].innerHTML=nowHtml.substr(0,nowLength)+'…';
//     }
//   }  
// }
// 导出excel
function downloadExcel(res,name){
  let blob = new Blob([res], {type: "application/vnd.ms-excel"}); 
  if( window.navigator.msSaveBlob ) {
  navigator.msSaveOrOpenBlob(blob,name);
    
  }else {      
  let a = document.createElement('a');
 
    // let blob = new Blob([res], {type: "application/vnd.ms-excel"}); 
    
    let objectUrl = URL.createObjectURL(blob);

    a.setAttribute("href",objectUrl);
    a.setAttribute("download", name);
    a.click();
    a.remove()
  }
}
export function DayTime(time, cFormat) {
  if (time === undefined || time === null || time === '') {
    return '——'
  }

  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
    // date = new Date(time.replace(/T/," ").replace(/-/g,"/").replace(/\.\d+(\+?.*$)/g,"$1"))
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
  }
  const time_str = format.replace(/{(y|m|d)+}/g, (result, key) => {    
  
    let value = formatObj[key]   //这是自定义星期几的格式
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}


export default  {
  downloadExcel
}